// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1hjXb","notes":"Notes_notes__2HgYe"};